export default {
  APP_LINK_REGISTER: {
    META: { TITLE: 'Apply now' },
    INTRO_SCREEN: {
      DESCRIPTION: '{{company}} is hiring for the <strong>{{jobOffer}}</strong> role through the wokap app.',
      BUTTON: 'Get started',
    },
    ACCESS_REGISTER_SCREEN: {
      MESSAGE_1: 'To apply for the [oferta] role, you need to:',
      MESSAGE_2: 'Record a video intro and upload your resume on the wokap app.\nOtherwise, [empresa] won\'t be able to review your profile or consider your application.\n',
    },
    INITIAL_REGISTER_SCREEN: {
      MESSAGE_1: 'To apply for the {{jobOffer}} role, you need to:',
      MESSAGE_2: 'Record a video intro and upload your resume on the wokap app.',
      DESCRIPTION: 'Otherwise, <strong>{{company}}</strong> won\'t be able to review your profile or consider your application.',
    },
    FORM_EMAIL: {
      TITLE: 'Email address',
      EMAIL: 'Enter your email',
      DATA_PROCESSING: 'I confirm that I have read, understood, and agree to the',
      DATA_PROCESSING_LINK: 'Terms and Conditions',
      DATA_PROCESSING_DESCRIPTION_1: ', the',
      DATA_PROCESSING_LINK_2: 'Privacy Policy',
      DATA_PROCESSING_DESCRIPTION_2: ', the use of cookies and similar technologies, and the processing and analysis of my activity on wokap according to its policies.',
      SHOW_OFFER: 'View offer',
    },
    FORM_PERSONAL_INFO: {
      TITLE: 'Personal info',
      DESCRIPTION: 'Fill in your details:',
      NAME: 'First name',
      LASTNAME: 'Last name',
      PHONE: 'WhatsApp',
      SHOW_OFFER: 'View offer',
      UPLOAD_CV: 'Upload resume (PDF)',
      REPLACE: 'Replace resume (PDF)',
      FILE: 'Current file:',
      UPLOAD_CV_SIZE_ERROR: 'File size exceeds the limit of',
    },
    FINAL_FORM: {
      TITLE: 'One last step',
      DESCRIPTION_1: 'Your application isn\'t complete yet.',
      DESCRIPTION_2: 'Record your video intro and upload your resume on the wokap app.',
      DESCRIPTION_3: 'Otherwise, {{company}} won\'t be able to consider you for the role.',
      DESCRIPTION_4: 'Download the wokap app and follow the instructions.',
      DESCRIPTION_5: 'When signing up, use this email: <strong>{{userEmail}}</strong>',
      DESCRIPTION_6: '<span class="download-link-text">Download the app</span> 👇🏽',
      PC_WARNING: '* If you’re on a computer, switch to your phone to download<br class="hidden sm:block">the wokap app and continue your application.',
    },
    FORM: {
      TITLE: 'Apply at <strong>{{company}}</strong>',
      DESCRIPTION: 'Enter your email to view the job details.',
      EMAIL: 'Email address',
      SUBMIT: 'I’m interested',
      SHOW_OFFER: 'View offer',
    },
    MODAL: {
      TITLE: 'Job details',
      REQUIREMENT_MINIMUM: 'Minimum requirements',
      REQUIREMENT_DESIRED: 'Preferred qualifications',
      SHARE_TEXT: 'Check out this job I just found!\n{{jobTitle}}',
    },
    FINALIZE: {
      TITLE: 'Download the <strong>wokap</strong> app to apply at <strong>{{company}}</strong>',
      DESCRIPTION: 'When you sign in to <strong>wokap</strong>, use your email to access this job.',
      DESCRIPTION_1: 'If you already have the <strong>wokap</strong> app, you can find this job in your notifications.',
      DOWNLOAD_IOS: 'Download for iOS',
      DOWNLOAD_ANDROID: 'Download for Android',
      DOWNLOAD_OTHER: 'Download the app',
    },
    COMMON: {
      CONTINUE: 'Continue',
      RETURN: 'Go back',
      CLOSE: 'Close',
      FINISH: 'Done',
    },
  },
} as const;
